import { useAuthenticator } from "@aws-amplify/ui-react";
import { useQuery } from "@tanstack/react-query";
import { TimeSeriesData } from "types/timeSeriesDataType";
import { useReverseUserId, fetchWithAlert } from "functions";

const fetchLatest = async (personCd: string): Promise<TimeSeriesData> => {
  return await fetchWithAlert(
    `${process.env.REACT_APP_AWS_CLOUDFRONT_URL}/time-series`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        person_cd: personCd,
        latest_data_only: "true",
      }),
    },
  );
};

export const useQueryLatest = () => {
  const { user } = useAuthenticator((context) => [context.authStatus]);
  const id = useReverseUserId(user);

  return useQuery({
    queryKey: [`Latest${id}`],
    queryFn: () => fetchLatest(user.username),
    staleTime: 60 * 60 * 1000, // NOTE: 1 hour
    enabled: !!user,
  });
};
